/*
 * Copyright (c) 2023 Class Technologies Inc. All rights reserved.
 */

import React from 'react';

import styled from 'styled-components';

import classLogoFull from '../images/class-logo-full-color-rgb-313px@72ppi.png';

const StyledImageFull = styled.img`
    max-width: 133px;
    max-height: 30px;
`;

const ClassLogoForHeaderFull = () => <StyledImageFull src={classLogoFull} alt="class logo"/>;

export default ClassLogoForHeaderFull;
